<script setup lang="ts">
import AccordionComponent from "@/components/accordion/AccordionComponent.vue";
import { defineProps, inject, ref, defineModel, watch } from "vue";
import { DestinyMatrix, DestinyMatrixKeysEnum } from "@/types/destinyMatrix";
import { useI18n } from "vue-i18n";

const props = defineProps<{
  matrix: DestinyMatrix | undefined;
  hasPremiumAccess: boolean;
}>();
const isOpen = defineModel<boolean>({ default: false });
const getDescription =
  inject<(key: DestinyMatrixKeysEnum) => Promise<never>>("getDescription");

const { t } = useI18n();

watch(
  () => props.matrix,
  () => (description.value = undefined)
);

const description = ref();

async function getData() {
  if (!props.hasPremiumAccess) {
    isOpen.value = false;
  }
  if (!description.value && props.matrix && getDescription) {
    description.value = await getDescription(
      DestinyMatrixKeysEnum.FAMILY_TASKS_7_GENERATION
    );
  }
}
</script>

<template>
  <AccordionComponent
    type="white"
    @opened="getData"
    v-model="isOpen"
    :isBlocked="!hasPremiumAccess"
  >
    <template #title>
      {{
        t(
          "calculators.destiny-matrix.accordions.family-tasks-7-generation.title"
        )
      }}
    </template>
    <template #faq-content>
      <div v-if="description" class="flex flex-col gap-2">
        <div class="whitespace-pre-line">
          {{
            t(
              "calculators.destiny-matrix.accordions.family-tasks-7-generation.desc"
            )
          }}
        </div>
        <p class="text-xl font-bold pt-4">
          {{
            t(
              "calculators.destiny-matrix.accordions.family-tasks-7-generation.male-tasks-father-line-title",
              { value: matrix.r1.tl }
            )
          }}
        </p>
        <div class="whitespace-pre-line">
          {{ description["male_tasks_father_line"] }}
        </div>
        <p class="text-xl font-bold pt-4">
          {{
            t(
              "calculators.destiny-matrix.accordions.family-tasks-7-generation.male-tasks-mother-line-title",
              { value: matrix.r3.l }
            )
          }}
        </p>
        <div class="whitespace-pre-line">
          {{ description["male_tasks_female_line"] }}
        </div>
        <p class="text-xl font-bold pt-4">
          {{
            t(
              "calculators.destiny-matrix.accordions.family-tasks-7-generation.female-tasks-father-line-title",
              { value: matrix.r2.l }
            )
          }}
        </p>
        <div class="whitespace-pre-line">
          {{ description["female_tasks_father_line"] }}
        </div>
        <p class="text-xl font-bold pt-4">
          {{
            t(
              "calculators.destiny-matrix.accordions.family-tasks-7-generation.female-tasks-mother-line-title",
              { value: matrix.r2.l }
            )
          }}
        </p>
        <div class="whitespace-pre-line">
          {{ description["female_tasks_mather_line"] }}
        </div>
      </div>
    </template>
    <template #collapse-text-btn>
      {{ t("calculators.destiny-matrix.accordions.collapse") }}
    </template>
  </AccordionComponent>
</template>
